<template>
  <div>
    <hr>
    <div class="alert alert-info">
      <slot/>
    </div>
  </div>
</template>
